import { ApplicationInsights, DistributedTracingModes, ITelemetryItem } from '@microsoft/applicationinsights-web';

import { getBaseDomain } from '../network/utils/getBaseDomain';
import { getInstrumentationKey } from './getInstrumentationKey';
import { isAppInsightActive } from './isAppInsightActive';

export enum Telemetry {
  ENVIRONMENT = 'Environment',
  APPLICATION = 'Application',
  CloudRoleName = 'ai.cloud.role',
}

export const RegexFilterForNameTelemetry = /^(GET|POST|PUT|DELETE) .*(\/cart\/cart\/|\/favourites\/api\/).*$/;

const instrumentationKey = getInstrumentationKey();

let appInsights: ApplicationInsights | undefined;

export const getAppInsights = () => appInsights;

const checkRegexTelemetry = (item: ITelemetryItem): boolean => {
  if (item?.baseData?.name?.match(RegexFilterForNameTelemetry)) {
    return true;
  }
  return false;
};

const addTelemetry = (item: ITelemetryItem): boolean => {
  if (item?.baseData?.properties) {
    item.baseData.properties[Telemetry.APPLICATION] = 'MV Agent';
    item.baseData.properties[Telemetry.ENVIRONMENT] = process.env.NODE_ENV;
  }

  if (!item.tags) {
    item.tags = [];
  }
  item.tags.push({
    [Telemetry.CloudRoleName]: 'MV Agent',
  });
  return true;
};

const tryToInitAppInsights = () => {
  if (instrumentationKey && window.ikea?.mvAgent.cookieConsent.hasConsent(2)) {
    if (!appInsights) {
      appInsights = new ApplicationInsights({
        config: {
          instrumentationKey,
          extensions: [],
          enableAutoRouteTracking: false,
          disableFetchTracking: false,
          disableCorrelationHeaders: false,
          enableCorsCorrelation: false,
          enableRequestHeaderTracking: true,
          enableResponseHeaderTracking: true,
          correlationHeaderDomains: [getBaseDomain],
          distributedTracingMode: DistributedTracingModes.W3C,
        },
      });
      appInsights.loadAppInsights();
      appInsights.addTelemetryInitializer((): boolean => {
        if (!isAppInsightActive) return false;
        return true;
      });
      appInsights.addTelemetryInitializer(checkRegexTelemetry);
      appInsights.addTelemetryInitializer(addTelemetry);
    }
  } else if (appInsights) {
    appInsights.unload();
    appInsights = undefined;
  }
};

tryToInitAppInsights();

document.addEventListener('mvAgentCookieConsent', tryToInitAppInsights);
